import SelectCar from "../images/plan/icon1.png";
import Contact from "../images/plan/icon2.png";
import Drive from "../images/plan/icon3.png";
import { Link  ,useHistory } from 'react-router-dom';

function PlanTrip(props) {

  let history = useHistory();


  return (
    <>
      <section className="plan-section">
        <div className="container">
          <div className="plan-container">
            <div className="plan-container__title">
              <h3>Quick & Easy Steps</h3>
              <h2>Book Car Rental Dubai Now              </h2>
            </div>

            <div className="plan-container__boxes">
              <div className="plan-container__boxes__box" onClick={()=>history.push("/categories/Cars/all-products")} style={{cursor:"pointer"}}>
                <center>
                <img src={SelectCar} alt="icon_img" />
                <h3>Pick The Ideal Car
                </h3>
                <p>
                Want to rent a car? Look through our extensive inventory to select the ideal vehicle for your journey.


                </p>

                </center>
              </div>

              <div className="plan-container__boxes__box" onClick={()=>history.push("/contact")}  style={{cursor:"pointer"}}>
                <center>

                <img src={Contact} alt="icon_img" />
                <h3>Paying Options
                </h3>
                <p>
                Customers have the option to pay for their purchases online or choose to pay through cash upon delivery.


                </p>
                </center>
              </div>

              <div className="plan-container__boxes__box">
                <center>

                <img src={Drive} alt="icon_img" />
                <h3>Delivery & Pick Up
                </h3>
                <p>
                Once the booking is confirmed, we will deliver your car to any location in Dubai.

    
                </p>
                </center>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PlanTrip;
